import React from 'react';

const TypeProfilRenderer = (props) => {
    // const alert = useAlert();
    // const [width, height] = useWindowSize();

    // const handleChange = (event) => {
    //     if (props.data && props.data.login) {
    //         axios({ method: 'put', url: URL_API + '/utilisateurs/' + props.data.login + '/' + event.target.value })
    //             .then(function () {
    //                 alert.success('Le rôle du compte [' + props.data.login + '] a été changé en [' + event.target.value + ']');
    //                 props.setNeedUpdate(true);
    //             })
    //             .catch(function (err) {
    //                 logError(alert, err);
    //             });
    //     }
    // };

    // return (
    //     <FormControl>
    //         <Select value={props.value} onChange={handleChange} style={{ margin: '10px', minWidth: '125px' }}>
    //             <MenuItem value="ADMINISTRATEUR_FONCTIONNEL">Admin. fonctionnel</MenuItem>
    //             <MenuItem value="ADMINISTRATEUR_TECHNIQUE">Admin. technique</MenuItem>
    //             <MenuItem value="SUPERVISEUR">Superviseur</MenuItem>
    //             <MenuItem value="TECHNICIEN">Technicien</MenuItem>
    //         </Select>
    //     </FormControl>
    // );

    return <div></div>

};

export default TypeProfilRenderer;